import { DatePickerInput, DatePickerInputProps } from "@mantine/dates"
import { useTranslation } from "react-i18next"
import { useSeasonPresets } from "./useSeasonPresets"

interface Props extends Omit<
  DatePickerInputProps<"range">,
  "type" | "presets" | "loading"
> {}

export function DateRangePickerInputWithSeasonPresets(props: Props) {
  const { t } = useTranslation("app_server")
  const { presets, isLoading } = useSeasonPresets()
  return (
    <DatePickerInput
      loading={isLoading}
      label={t("TimePeriod")}
      type="range"
      presets={presets}
      {...props}
    />
  )
}
